<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Rejected Reason</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                                
                <div class="row">                    

                    <div class="form-group col-md-12">
                        <label>Reason</label>
                        <textarea v-model="reason" class="form-control"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn btn-warning btn-round" v-on:click="Save()">Reject</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>

    export default {
        props: ['show', 'type'],
        data: function () {
            return {
                reason:''
            }
        },
        methods: {

            Save: function () {
                this.$emit('input', this.reason);
            },


            close: function () {
                this.$emit('close');                
            }
        },

        mounted: function () {

        },

    }
</script>